/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Edit_LogisticsInputs */

const en_orders_edit_logistics = /** @type {(inputs: Orders_Edit_LogisticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Logistics`)
};

const es_orders_edit_logistics = /** @type {(inputs: Orders_Edit_LogisticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar logistica`)
};

/**
* | output |
* | --- |
* | "Edit Logistics" |
*
* @param {Orders_Edit_LogisticsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_edit_logistics = /** @type {((inputs?: Orders_Edit_LogisticsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Edit_LogisticsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_edit_logistics(inputs)
	return es_orders_edit_logistics(inputs)
});